<template>
    <div>
        <div class="flex">
            <div class="mr-auto leading-loose">
                <div class="text-lg font-bold">{{ header }}</div>
                <div class="text-lg text-top">{{ price | toCurrency }}</div>
            </div>
            <div>
                <template v-if="!(soldOut || isSoldOut) || quantityInBasket > 0">
                    <button v-if="quantityInBasket == 0" @click="addToBasket()" class="w-40 py-2 px-5 bg-top text-top-text rounded-sm border-0 font-bold hover:bg-top shadow-none hover:shadow-sm hover:cursor-pointer transition-all duration-3s">Tilføj til kurv</button>
                    <div v-if="quantityInBasket > 0" class="inline-flex items-center transition-all duration-3s" :class="[loading ? 'opacity-50' : 'opacity-100']">
                        <button @click="addQuantity(-1)" :disabled="addedQuantityInBasket == 0" class="block rounded-full outline-none border-gray-300 border text-black w-8 h-8 text-lg font-bold bg-white text-center transition-all duration-3s" :class="[loading ? 'opacity-50 cursor-default' : 'opacity-100 cursor-pointer']">-</button>
                        <span class="mx-2 w-10 text-center font-bold text-black">{{ addedQuantityInBasket }}</span>
                        <button @click="addQuantity(1)"
                            :disabled="maxForSale > 0 && addedQuantityInBasket >= maxForSale"
                            :title="maxForSale > 0 && addedQuantityInBasket >= maxForSale ? 'Du kan ikke tilføje flere til kurven' : ''"
                            class="block rounded-full outline-none border-gray-300 border text-black w-8 h-8 text-lg font-bold bg-white text-center transition-all duration-3s"
                            :class="[loading || (maxForSale > 0 && addedQuantityInBasket >= maxForSale) ? 'opacity-50 cursor-default' : 'opacity-100 cursor-pointer']">+</button>
                    </div>
                </template>
                <template v-else-if="waitingListAllowed">

                    <button @click="addToWaitingList = true" class="w-40 py-2 bg-top text-top-text rounded-sm border-0 font-bold hover:bg-top shadow-none hover:shadow-sm hover:cursor-pointer transition-all duration-3s">Tilmeld venteliste</button>
                    <add-to-waiting-list-button :product-id="productId" :visible="addToWaitingList" @close="addToWaitingList = false" />
                </template>
                <div v-else class="w-40 py-2 px-5 border outline-none border-gray-300 rounded-sm text-center">Udsolgt</div>
            </div>
        </div>
				<div>
					<slot></slot>
				</div>
    </div>
</template>

<script>
import debounce from "lodash/debounce";
import store from "./store";
import AddToWaitingListButton from "./AddToWaitingListButton";

export default {
    components: {
        AddToWaitingListButton
    },
    data() {
        return {
            toAdd: 0,
            loading: false,
						addToWaitingList: false,
						isSoldOut: false,
        }
    },
    props: {
        productId: String,
				header: String,
				price: Number,
        soldOut: Boolean,
        waitingListAllowed: Boolean,
        maxForSale: Number
    },
    computed: {
        quantityInBasket: function() {
            return this.$store.getters.quantityInBasket(this.productId);
        },
        addedQuantityInBasket: function() {
            return this.quantityInBasket + this.toAdd;
        }
    },
    methods: {
        addToBasket: function(add) {
            this.$store.dispatch("addToBasket", {
                productId: this.productId
            }).then(response => {}).catch(response => {
                if (response.noSuccess) {
                    this.$store.dispatch("updateBasket").then(r => {
                        setTimeout(() => {
                        if (this.quantityInBasket == 0) {
                            alert(response.message)
                            this.isSoldOut = true;
                        }
                        }, 100);
                    })
                }
            });
        },
        addQuantity: function(add) {
            if (!this.loading)
            {
                this.toAdd = this.toAdd + add;
                this.updateBasketCount(this.toAdd);
            }
        },
        updateBasketCount: debounce(function () {
            this.loading = true;
            this.$store.dispatch("updateBasketQuantity", {
                productId: this.productId,
                quantity: Math.max(0, this.quantityInBasket + this.toAdd)
            }).then(() => {
                this.toAdd = 0;
                this.loading = false;
            })
        }, 500)
    }
}
</script>
